export default "/fonts/TiemposHeadline-Regular.woff?5f9b88d5558af0346ea1c4b3caaac427";